<template>
  <div>

    <div class="postTitleStyle">
      <div>
        <div :class="isLogin ? 'postTitleStyle_name' : 'postTitleStyle_name_login'" @click="login">
          <img v-if="user_avatar" :src="user_avatar" class="header_img" alt="" />
          <img v-else :src="user_avatar" class="header_img" alt="" />
          <div class="bee_star_username">{{ userName }}</div>
        </div>
      </div>
      <div class="postTitleStyle">

        <div v-show="isShowPostStar" class="disComment_cs">
          <div class="bee_star_content">Comments:</div>
          <star-rating @update:rating="updateScore" :rating="score" :read-only="isReadOnly" :show-rating="false"
            :increment="0.5" :star-size="16" style="margin-left: 4px; margin-right: 4px;margin-bottom: 4px;" />
        </div>
        <div v-if="isPosting" class="bee_post_loading">
          <div class="loading_logo"></div>
        </div>
        <div v-else :class="isSend ? 'bee_post' : 'bee_un_post'" @click="post">Post</div>
      </div>
    </div>

    <div class="bee_star_base_layout" style="margin-top: 16px">
      <textarea id="comment" class="inputLayoutStyle" @input="onInput" v-model="content"
        :placeholder="placeholder"> </textarea>
    </div>
  </div>
</template>
<script>

import StarRating from "vue-star-rating";
import { base_url, getPostId } from '../util/mock.js';
import { AccountStore } from "../util/Account.js";
import default_avatar from '../assets/default_avatar.png';
import Toast from "../components/message.js";
import { addEmit, resultEmitEvent } from "../util/event";
export default {
  name: 'postCommentView',
  components: { StarRating },
  props: {
    comment_parent: "",
    isShowPostStar: false,
    count: 0,
  },
  data() {
    return {
      user_avatar: "",
      userName: "Login",
      show: false,
      content: '',
      score: 0,
      placeholder: "Come comment～",
      isPosting: false,
      isLogin: false,
      isSend: false,
      isReadOnly: false,

    }
  },

  watch: {

  },

  methods: {

    updateScore(s) {
      this.score = s;
      // if (this.content != "") {
      this.isSend = true;
      // }
      console.log(s);
    },

    formatDate(date) {
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份是从0开始的
      const year = date.getFullYear();
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    login() {
      if (AccountStore.accountInfo == null || AccountStore.accountInfo.user_id == undefined
        || AccountStore.accountInfo.user_id == null) {
        // Toast("Please log in first", "error");
        window.location.href = AccountStore.loginUrl;
        return;
      }
    },

    async post() {
      let post_id = getPostId();
      let comment_time = this.formatDate(new Date());

      if (AccountStore.accountInfo == null || AccountStore.accountInfo.user_id == undefined
        || AccountStore.accountInfo.user_id == null) {
        // Toast("Please log in first", "error");
        window.location.href = AccountStore.loginUrl;
        return;
      }

      if (this.content == "") {
        Toast("Please enter the comment content", "error");
        return;
      }
      // if (this.score == 0) {
      //   Toast("Please enter the project rating first", "error");
      //   return;
      // }

      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        body: new URLSearchParams({
          action: 'bee_user_post_comment_score_callback',
          post_id: post_id,
          score: this.score,
          comment_content: this.content,
          comment_time: comment_time,
          comment_parent: this.comment_parent,
        }),
      };

      if (this.isPosting) {
        return;
      }
      this.isPosting = true;
      const ajaxData = await fetch(`${base_url()}/wp-admin/admin-ajax.php`, options)
      let data = await ajaxData.json();
      let rData = data.data;
      if (rData.code == 200) {
        this.content = "";
        this.isSend = false;
        Toast("Comment successful", "success");
        if (this.count < 10) {
          addEmit('commentTypeListener', 1);
        }
      }
      this.isPosting = false;
    },

    async getInitData() {
      let post_id = getPostId();
      // console.log(post_id + "=====post_id===" + window.location.href);
      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        body: new URLSearchParams({
          action: 'bee_get_post_user_info_callback',
          _wpnonce: "wp_nonce",
          post_id: post_id,
        }),
      };

      const ajaxData = await fetch(`${base_url()}/wp-admin/admin-ajax.php`, options)
      let data = await ajaxData.json();
      let userData = data.data.data;
      // console.log(userData.user)
      this.score = userData.uScore;
      if (this.score != 0) {
        this.isReadOnly = true;
      }
      AccountStore.setValue(userData.user);
      AccountStore.setLoginUrl(userData.loginUrl);
      if (AccountStore.accountInfo == null || AccountStore.accountInfo.user_id == undefined
        || AccountStore.accountInfo.user_id == null) {
        this.isLogin = false;
      } else {
        this.isLogin = true;
        if (AccountStore.accountInfo.avatar != "") {
          this.user_avatar = AccountStore.accountInfo.avatar;
        } else {
          this.user_avatar = default_avatar;
        }
        if (AccountStore.accountInfo.user_display_name != "") {
          this.userName = AccountStore.accountInfo.user_display_name
        } else {
          this.userName = AccountStore.accountInfo.user_email
        }
      }

    },

    onInput() {
      if (this.content != "") {
        this.isSend = true;
      } else {
        this.isSend = false;
      }
    }

  },

  mounted() {
    this.user_avatar = default_avatar;
    this.getInitData();
  },


}

</script>

<style scoped>
.bee_star_base_layout {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.postTitle_comment_Style {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.postTitleStyle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.postTitleStyle_name {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

@media (max-width:767.98px) {
  .postTitleStyle_name {
    display: none;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
}

.postTitleStyle_name_login {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

@media (max-width:767.98px) {
  .postTitleStyle_name_login {
    display: none;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
}


.inputLayoutStyle {
  display: flex;
  min-height: 60px;
  background-color: #f8f8f8;
  border-radius: 8px;
  width: 100%;
  border-color: #f8f8f8;
  padding: 4px;
}

.header_img {
  width: 38px;
  height: 38px;
  border-radius: 100%;
}

.bee_star_push {
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: #999999;
  margin-right: 16px;
}

.bee_star_username {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
  color: #666;
  margin-left: 4px;
}

.bee_post {
  height: 28px;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 4px;
  background-color: #FFAC13;
  color: #fff;
  font-family: SF Pro Text;
  font-size: 14px;
  font-weight: 400;
  line-height: 28px;
  text-align: left;
  margin-left: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.bee_un_post {
  height: 28px;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 4px;
  background-color: #f2f1ef;
  color: #d4d1c9;
  font-family: SF Pro Text;
  font-size: 14px;
  font-weight: 400;
  line-height: 28px;
  text-align: left;
  margin-left: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}


.bee_post_loading {
  height: 28px;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 4px;
  background-color: #FFAC13;
  color: #fff;
  font-family: SF Pro Text;
  font-size: 14px;
  font-weight: 400;
  line-height: 28px;
  text-align: left;
  margin-left: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.comment_count_txt {
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  text-align: left;
  color: rgba(153, 153, 153, 1);
}

.line_type {
  border: 1px solid #E4E4E4;
  height: 19px;
  margin-left: 8px;
  margin-right: 8px;
}

.bee_star_title {
  font-family: SF Pro Text;
  font-size: 20px;
  font-weight: 600;
  line-height: 22px;
  text-align: left;
  color: #000;
}

.comment_type_title {
  font-family: SF Pro Text;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  text-align: left;
  color: #999;
}

.comment_type_title_foce {
  font-family: SF Pro Text;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  text-align: left;
  color: #000;
}

.bee_star_content {
  font-family: SF Pro Text;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: #333;
}

.disComment_cs {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.loading_logo {
  width: 18px;
  height: 18px;
  background-image: url("../assets/icon_loading.png");
  background-size: cover;
  background-repeat: no-repeat;
  animation: rotate 2s linear infinite;
}


@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
